import { useQuery } from "react-query";
import * as userCustomApi from "../../../util/api";
import useAuthToken from "../../../hooks/useAuthToken";

export const useGetUserCustomApps = (isArchive: boolean, enterpriseId: string) => {
    const token = useAuthToken();

    return  useQuery(
        !isArchive ? 'userCards' : 'archiveUserCards',
        () => !isArchive ? userCustomApi.fetchUserCards(token, enterpriseId) :
        userCustomApi.fetchArchiveUserCards(token, enterpriseId)

    );
}
